module.exports = __webpack_public_path__ + "img/email-capture-precious.a2750fc.png";